import { Instagram, Phone } from "lucide-react";
import { site } from "@/config/site";
import { contactFaq } from "@/content/home";
import { Seo } from "@/components/Seo";
import { LocalBusinessJsonLd } from "@/components/LocalBusinessJsonLd";
import { PageHero } from "@/components/PageHero";
import { WhatsAppIcon } from "@/components/CtaButtons";
import { MapSection } from "@/components/MapSection";
import { Faq } from "@/components/Faq";
import { CtaBlock } from "@/components/CtaBlock";

const cards = [
  { icon: <WhatsAppIcon className="w-6 h-6" />, color: "text-whatsapp", title: "WhatsApp", value: site.phoneDisplay, href: site.whatsappUrl, external: true, testId: "contact-whatsapp-card" },
  { icon: <Phone className="w-6 h-6" aria-hidden="true" />, color: "text-gold", title: "Telefon", value: site.phoneDisplay, href: site.phoneTel, testId: "contact-phone-card" },
  { icon: <Instagram className="w-6 h-6" aria-hidden="true" />, color: "text-emerald", title: "Instagram", value: "@lavenzaspabursa", href: site.instagram, external: true, testId: "contact-instagram-card" },
];

export default function Contact() {
  return (
    <>
      <Seo
        title="İletişim & Randevu | Lavenza Masaj Salonu Bursa Nilüfer"
        description="Lavenza Masaj Salonu Bursa Nilüfer iletişim bilgileri: adres, telefon, WhatsApp randevu hattı, çalışma saatleri ve yol tarifi. Konak Mahallesi, Kurşunlu Sokak."
        path="/iletisim"
      />
      <LocalBusinessJsonLd />
      <PageHero
        eyebrow="İletişim"
        accent="İletişim &"
        title="Randevu"
        text={`Bursa Nilüfer'deki Lavenza Masaj Salonu'na WhatsApp'tan yazarak ya da arayarak kolayca randevu alabilirsiniz. ${site.priceNote}`}
        crumbs={[{ label: "Ana Sayfa", path: "/" }, { label: "İletişim", path: "/iletisim" }]}
        testId="contact-hero"
      />
      <section className="section bg-white" data-testid="contact-cards-section">
        <ul className="container-wide grid gap-5 md:grid-cols-3" data-testid="contact-cards">
          {cards.map((c) => (
            <li key={c.title} className="card p-6 hover-lift">
              <span className={`${c.color} inline-block mb-3`}>{c.icon}</span>
              <h2 className="font-bold text-lg">{c.title}</h2>
              <a href={c.href} target={c.external ? "_blank" : undefined} rel={c.external ? "noopener noreferrer" : undefined} className="text-base font-semibold text-emerald hover:text-gold transition-colors" data-testid={c.testId}>{c.value}</a>
            </li>
          ))}
        </ul>
      </section>
      <MapSection accent="Adres, Harita &" title="Çalışma Saatleri" />
      <Faq items={contactFaq} title="Randevu Hakkında Sık Sorulanlar" lead="Randevu ve ulaşım ile ilgili kısa yanıtlar" />
      <CtaBlock showAppointmentLink={false} title="Randevunuzu" accent="Şimdi" tail="Oluşturun" />
    </>
  );
}
